var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
typeof window !== 'undefined' &&
    !window.__DS_WEB_VERSION__ &&
    (window.__DS_WEB_VERSION__ = '2.4.0');
import { Spinner } from '../Spinner';
import { buttonDefaultProps } from './props';
import * as S from './styles';
const Icon = ({ icon, size = buttonDefaultProps.size }) => {
    if (!icon)
        return null;
    return (React.createElement(S.IconWrapper, { "data-testid": "icon-button", size: size }, icon));
};
const IsLoading = ({ size = buttonDefaultProps.size }) => {
    return (React.createElement(S.IsLoadingWrapper, { "data-testid": "is-loading-spinner", size: size },
        React.createElement(Spinner, { "aria-label": "loading", color: "currentColor", size: size === 'small' ? 'extra-small' : 'small' })));
};
/**
 * Componente de botão do Design System OLX.
 *
 * Além das props explícitas aqui, também aceita todas as props que poderiam ser passadas para o elemento `<button>` do HTML
 */
export const Button = forwardRef((_a, ref) => {
    var { tag, as, href, className, disabled, dsParentName } = _a, props = __rest(_a, ["tag", "as", "href", "className", "disabled", "dsParentName"]);
    return (React.createElement(S.ButtonWrapper, Object.assign({ "data-testid": "button-wrapper", "data-ds-component": dsParentName ? `DS-${dsParentName}-Button` : `DS-Button`, className: [className, disabled && 'disabled'].filter(Boolean).join(' '), disabled: disabled, ref: ref, as: tag || as }, ((tag === 'a' || as === 'a') && { href }), props),
        props.isLoading && React.createElement(IsLoading, { size: props.size }),
        React.createElement(S.ContentWrapper, { isLoading: props.isLoading },
            React.createElement(Icon, Object.assign({}, props)),
            " ",
            props.children)));
});
Button.defaultProps = buttonDefaultProps;
Button.displayName = 'Button';
